import { AttachmentsConfig, MetaPayload } from 'types';

interface initialStateInterface {
  isOpen: boolean;
  isRestarted: boolean;
  isMinimized: boolean;
  isRetrying?: boolean;
  isDialogEnded: boolean;
  isChatDisabled: boolean;
  isSessionExpired: boolean;
  activeApiUrl?: string;
  failedApiUrls?: string[];
  withAgent?: boolean;
  matchFeedbackType?: boolean;
  meta?: MetaPayload;
  isHistory?: boolean;
  isAgentConnecting?: boolean;
  isAgentConnected?: boolean;
  isAgentTimeout?: boolean;
  isSensitiveInput?: boolean;
  data: {
    id: string;
    meta?: Record<string, any>;
    data?: Record<string, any>;
    thread: object[];
  };
  start: {
    isLoaded: boolean;
    isLoading: boolean;
    error: string;
  };
  ask: {
    isLoading: boolean;
    error: string;
  };
  attachmentsConfig: AttachmentsConfig;
  debugInfo?: any;
}

const initialState: initialStateInterface = {
  isOpen: false,
  isRestarted: false,
  isMinimized: false,
  isRetrying: false,
  isDialogEnded: false,
  isChatDisabled: false,
  isSessionExpired: false,
  activeApiUrl: '',
  failedApiUrls: [],
  withAgent: false,
  matchFeedbackType: false,
  meta: null,
  isHistory: false,
  isAgentConnecting: false,
  isAgentConnected: true,
  isAgentTimeout: false,
  isSensitiveInput: false,
  data: {
    id: '',
    thread: [],
  },
  start: {
    isLoaded: false,
    isLoading: false,
    error: '',
  },
  ask: {
    isLoading: false,
    error: '',
  },
  attachmentsConfig: {
    allowedTypes: [],
    attachmentsEnabled: false,
    attachmentsRichEnabled: false,
    maxFileSize: 0,
    maxFiles: 0,
  },
  debugInfo: null,
};

export default initialState;
